import { render, staticRenderFns } from "./Tenders.vue?vue&type=template&id=990052c4&scoped=true"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"
import style0 from "./Tenders.vue?vue&type=style&index=0&id=990052c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990052c4",
  null
  
)

export default component.exports